module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/DATA SCIENCE-3de023463785d1ba454fe5cd92ce9f4c.png";